import { GzToastNotificationWebComponent } from '../ui/gzToastNotification';
import { ToastPositionX, ToastPositionY, ToastSeverity } from '../ui/gzToastNotification/type';

export class ToastService {
  public static showSuccessToast(message: string): void {
    this.buildToast(message, ToastSeverity.SUCCESS);
  }

  public static showErrorToast(message: string): void {
    this.buildToast(message, ToastSeverity.ERROR);
  }

  private static buildToast(message: string, severity: ToastSeverity): void {
    GzToastNotificationWebComponent.buildToastWrapperElement({
      message,
      severity,
      x: ToastPositionX.RIGHT,
      y: ToastPositionY.BOTTOM,
    });
  }
}
